'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HotelNameAndAdress;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _emailStyleTools = require('helpers/emailStyleTools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HotelNameAndAdress(props) {
  var name = props.name,
      address = props.address,
      components = props.components;


  var styleHotelInfoTitleLabel = (0, _emailStyleTools.textStyles)(components, 'HotelInfoTitleLabel');
  var styleHotelInfoValueLabel = (0, _emailStyleTools.textStyles)(components, 'HotelInfoValueLabel');

  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'HotelNameAndAdress' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(
            'span',
            { style: styleHotelInfoTitleLabel },
            name
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(
            'span',
            { style: styleHotelInfoValueLabel },
            address
          )
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Hotel/Email/Active/HotelNameAndAddress.jsx
// module id = 1523
// module chunks = 0